import { render, staticRenderFns } from "./TenantCreateForm.vue?vue&type=template&id=1bf531fe&scoped=true"
import script from "./TenantCreateForm.vue?vue&type=script&lang=js"
export * from "./TenantCreateForm.vue?vue&type=script&lang=js"
import style0 from "./TenantCreateForm.vue?vue&type=style&index=0&id=1bf531fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf531fe",
  null
  
)

export default component.exports